define('view/helper/TemplatePrecompiled',['require','handlebars'],function (require) {

    var Handlebars = require('handlebars');

    /**
     * Precompiled Handlebars template support (CY1SDEV1-3838).
     *
     * The per-theme bundles (htdocs/v2/themes/<theme>/templates.precompiled.js, built by
     * theme gulp `build_templates`) are loaded as plain <script> in the layout and fill
     * window.__tplSpecs, keyed by template path — the same string the {js_template template="..."}
     * calls pass, which each inlined <script type="text/html" id="..." data-path="..."> block also
     * carries as data-path.
     *
     * This module (a) hydrates VIEW templates into Handlebars.templates['#'+id] so the Marionette
     * adapter serves them via getPrecompiledTemplate() without Handlebars.compile(), and (b) exports
     * templateFor(selector) so PARTIAL registrations (TemplatePartials.js + plugins) can register a
     * precompiled function instead of a raw string.
     *
     * Fallback-safe throughout: when a spec is missing (bundle absent because the server flag is
     * off, template not in the bundle, or a spec fails to instantiate) it degrades to today's
     * behavior — the adapter runtime-compiles the DOM string, and templateFor returns that string
     * for Handlebars to compile lazily. So this is safe to ship before 'unsafe-eval' is dropped.
     */

    /**
     * Return a ready template function for a DOM template block when its precompiled spec exists,
     * else the raw template string (Handlebars will runtime-compile it on use — today's behavior).
     * Suitable as the 2nd arg to Handlebars.registerPartial (accepts a function or a string).
     */
    function templateFor(selector) {
        var $node = jQuery(selector);
        var el = $node[0];
        var specs = window.__tplSpecs;

        if (el && specs) {
            var path = el.getAttribute('data-path');
            if (path && specs[path]) {
                try {
                    return Handlebars.template(specs[path]);
                } catch (e) {
                    // fall through to the raw string
                }
            }
        }

        return $node.html();
    }

    // Hydrate view templates. Only precompiled functions are stored — a miss leaves the key unset
    // so the adapter falls back to runtime-compiling the DOM string.
    if (window.__tplSpecs) {
        Handlebars.templates = Handlebars.templates || {};

        jQuery('script[type="text/html"][data-path]').each(function () {
            var id = this.id;
            var path = this.getAttribute('data-path');

            if (!id || !path || !window.__tplSpecs[path]) {
                return;
            }

            var key = '#' + id;
            if (Handlebars.templates[key]) {
                return;
            }

            try {
                Handlebars.templates[key] = Handlebars.template(window.__tplSpecs[path]);
            } catch (e) {
                // Leave unset → adapter falls back to runtime-compiling the DOM string.
            }
        });
    }

    return {
        templateFor: templateFor
    };
});

